import{defineMessages}from"react-intl";export var messages=defineMessages({details:{id:"jutro-checkbox.details.ariaLabel",defaultMessage:"Details for {id}"}});